import React from 'react';
import { Box, Stack } from '@mui/material';
import Skeleton from '@/components/@IntranetLibrary/Skeleton';

const BoardFormSkeleton = () => (
  <Box>
    <Stack sx={{ gap: '8px' }}>
      <Skeleton variant="rect" width="140px" height="36px" />
      <Skeleton variant="rect" width="100%" height="36px" />
      <Skeleton variant="rect" width="80%" height="36px" />
    </Stack>
    <Stack sx={{ gap: '8px', marginTop: '24px' }}>
      <Skeleton variant="rect" width="100%" height="300px" />
      <Skeleton variant="rect" width="100%" height="36px" />
      <Skeleton variant="rect" width="80%" height="36px" />
    </Stack>
    <Stack sx={{ gap: '8px', marginTop: '24px' }}>
      <Skeleton variant="rect" width="200px" height="36px" />
      <Skeleton variant="rect" width="100%" height="36px" />
      <Skeleton variant="rect" width="80%" height="36px" />
    </Stack>
  </Box>
);

export default BoardFormSkeleton;
